




















import {Component, Vue} from 'vue-property-decorator';

@Component({})
export default class CustomCursor extends Vue {
	x: number | null = null;
	y: number | null = null;

	isHovered: boolean = false;
	thema: string = 'blue';
	whiteItems: any | null;

	$refs: {
		dot: HTMLElement
		outline: HTMLElement
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}

		this.whiteItems = document.querySelectorAll('[data-hover="white"]');

		let x = this.checkIfDevice();

		if (!x) {
			let html = document.getElementsByTagName('html')[0];
			html.classList.add('custom-cursor');
			window.addEventListener('mousemove', (e: any) => {
				this.handleMouseMove(e);
			});

			this.handleThema();

		}
	}

	handleThema(): void {
		if (!(this.whiteItems && this.whiteItems.length)) {
			return;
		}
		Array.prototype.forEach.call(this.whiteItems, (item: any) => {
			item.addEventListener('mouseenter', (e: any) => {
				this.thema = 'white';
			});
			item.addEventListener('mouseleave', (e: any) => {
				this.thema = 'blue';
			});
		});
	}

	checkIfDevice(): boolean {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	}

	handleMouseMove($event: MouseEvent): void {

		let element = $event.target as Element;

		if (!element) {
			return;
		}

		if (typeof $event.clientX === 'undefined') {
			return;
		}

		this.x = $event.clientX;
		this.y = $event.clientY;

		this.$refs.dot.style.top = `${$event.clientY}px`;
		this.$refs.dot.style.left = `${$event.clientX}px`;

		setTimeout(() => {
			this.$refs.outline.style.top = `${$event.clientY}px`;
			this.$refs.outline.style.left = `${$event.clientX}px`;
		}, 60);


		if (element.getAttribute('data-hovered') === 'true' && !this.isHovered) {
			this.isHovered = true;
		} else if (element.getAttribute('data-hovered') !== 'true' && this.isHovered) {
			this.isHovered = false;
		}

	}

	beforeDestroy(): void {
		if (!(this.whiteItems && this.whiteItems.length)) {
			return;
		}
		this.whiteItems.forEach((item: any) => {
			item.removeEventListener('mouseenter');
			item.removeEventListener('mouseleave');
		});
	}

}
